<div class="container mx-auto p-4 bg-[#F5F7FA] min-h-screen">
  
    <!-- Loader -->
    <div *ngIf="isLoading" class="flex items-center justify-center py-20">
      <div class="animate-spin rounded-full h-12 w-12 border-b-2 border-[#FF5C01]"></div>
    </div>

    <div *ngIf="!isLoading && plan" class="space-y-6">
        <!-- En-tête de la page -->
        <div class="flex justify-between items-center">
            <div class="flex items-center space-x-4">
                <button (click)="router.navigate(['/abonnements'])" class="text-gray-600 hover:text-gray-900">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 19l-7-7m0 0l7-7m-7 7h18" />
                    </svg>
                </button>
                <h1 class="text-2xl font-bold text-[#1E293B]">Détails du plan</h1>
            </div>
            <div class="flex space-x-3">
                <!-- Bouton Modifier (couleur #0d47a1) -->
                <button 
                    (click)="editPlan()"
                    class="bg-[#0d47a1] hover:bg-[#0a3a82] text-white px-6 py-2 rounded-lg font-medium transition-colors duration-200 shadow-md">
                    Modifier
                </button>
                <!-- Bouton Désactiver/Activer -->
                <button 
                (click)="openToggleModal()"
                class="border border-[#FF5C01] text-[#FF5C01] px-6 py-2 rounded-lg font-medium transition-colors duration-200 hover:bg-orange-50">
                {{ plan.active ? 'Désactiver' : 'Activer' }}
            </button>
            </div>
        </div>

        <!-- Contenu principal en grille -->
        <div class="grid grid-cols-1 lg:grid-cols-3 gap-6">
            
            <!-- Colonne de gauche (Détails du plan et Fonctionnalités) - UNE SEULE CARTE -->
            <div class="lg:col-span-1 space-y-6">
                <div class="bg-white p-6 rounded-xl shadow-sm space-y-6">
                    
                    <!-- Bloc d'informations principales -->
                    <div class="space-y-4">
                        <h2 class="text-xl font-extrabold text-gray-900 uppercase">{{ plan.label }}</h2>
                        <p class="text-gray-600">{{ plan.description }}</p>
                        <span class="px-3 py-1 rounded-full text-xs font-medium" [ngClass]="getStatutClass(plan.active)">
                            {{ getStatutText(plan.active) }}
                        </span>
                    </div>

                    <!-- Bloc Détails du plan -->
                    <div class="space-y-4 pt-4 border-t border-gray-200">
                        <h3 class="text-lg font-semibold text-gray-800">Détails du plan</h3>
                        <div class="grid grid-cols-2 gap-4 text-sm">
                            <!-- Coût total -->
                            <div>
                                <p class="text-gray-500">Coût total</p>
                                <p class="font-semibold text-gray-900">{{ formatAmount(plan.totalCost) }}</p>
                            </div>
                            <!-- Échéances -->
                            <div>
                                <p class="text-gray-500">Échéances</p>
                                <p class="font-semibold text-gray-900">{{ plan.installmentCount }}</p>
                            </div>
                            <!-- Limite projets -->
                            <div>
                                <p class="text-gray-500">Limite projets</p>
                                <p class="font-semibold text-gray-900">{{ getProjectLimit(plan) }}</p>
                            </div>
                            <!-- Remise annuelle -->
                            <div>
                                <p class="text-gray-500">Remise annuelle</p>
                                <p class="font-semibold text-gray-900">{{ plan.yearlyDiscountRate }}%</p>
                            </div>
                        </div>
                    </div>

                    <!-- Bloc Fonctionnalités (Mocké car non dans l'interface SubscriptionPlan) -->
                    <div class="space-y-4 pt-4 border-t border-gray-200">
                        <h3 class="text-lg font-semibold text-gray-800">Fonctionnalités</h3>
                        <ul class="space-y-3 text-gray-700">
                            <li class="flex items-center">
                                <svg class="h-5 w-5 text-orange-500 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
                                </svg>
                                Gestion de projets illimitée
                            </li>
                            <li class="flex items-center">
                                <svg class="h-5 w-5 text-orange-500 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
                                </svg>
                                Tableau de bord avancé
                            </li>
                            <li class="flex items-center">
                                <svg class="h-5 w-5 text-orange-500 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
                                </svg>
                                Rapports personnalisés
                            </li>
                            <li class="flex items-center">
                                <svg class="h-5 w-5 text-orange-500 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
                                </svg>
                                Support prioritaire
                            </li>
                            <li class="flex items-center">
                                <svg class="h-5 w-5 text-orange-500 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
                                </svg>
                                Intégrations API
                            </li>
                        </ul>
                    </div>
                      <!-- Bouton Supprimer (Reste en dehors de la carte principale) -->
                      <button 
                      (click)="openDeleteModal()"
                      class="w-full border border-orange-500 text-orange-500 px-6 py-3 rounded-lg font-medium transition-colors duration-200 hover:bg-orange-50">
                      Supprimer
                  </button>
                </div>

              
            </div>

            <!-- Colonne de droite (Graphique et Utilisateurs) -->
            <div class="lg:col-span-2 space-y-6">
                
                <!-- Bloc Répartition des abonnements (Chart.js) -->
                <div class="bg-white p-6 rounded-xl shadow-sm">
                    <h3 class="text-lg font-semibold text-gray-800 border-b pb-3 mb-4">Répartition des abonnements</h3>
                    <!-- <div class="flex flex-col md:flex-row items-center justify-around space-y-4 md:space-y-0">
                        <div class="w-48 h-48">
                            <canvas #distributionChart></canvas>
                        </div>
                        <div class="space-y-3">
                            <div class="flex items-center text-gray-700">
                                <span class="h-3 w-3 rounded-full bg-[#10B981] mr-2"></span>
                                Payé • {{ distributionData.paid }}%
                            </div>
                            <div class="flex items-center text-gray-700">
                                <span class="h-3 w-3 rounded-full bg-[#EF4444] mr-2"></span>
                                Impayé • {{ distributionData.unpaid }}%
                            </div>
                        </div>
                    </div> -->
                </div>

                <!-- Bloc Utilisateurs abonnés -->
                <div class="bg-white p-6 rounded-xl shadow-sm">
                    <h3 class="text-lg font-semibold text-gray-800 border-b pb-3 mb-4">Utilisateurs abonnés</h3>
                    <!-- <div class="overflow-x-auto">
                        <table class="min-w-full divide-y divide-gray-200">
                            <thead class="bg-gray-50">
                                <tr>
                                    <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Utilisateur</th>
                                    <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Rôle</th>
                                    <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Statut</th>
                                    <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Action</th>
                                </tr>
                            </thead>
                            <tbody class="bg-white divide-y divide-gray-200">
                                <tr *ngFor="let user of subscribedUsers">
                                    <td class="px-6 py-4 whitespace-nowrap">
                                        <div class="flex items-center">
                                            <div class="flex-shrink-0 h-10 w-10">
                                                <img class="h-10 w-10 rounded-full bg-gray-200" [src]="user.avatarUrl" alt="Avatar" onerror="this.onerror=null; this.src='https://via.placeholder.com/40'">
                                            </div>
                                            <div class="ml-4">
                                                <div class="text-sm font-medium text-gray-900">{{ user.name }}</div>
                                                <div class="text-sm text-gray-500">{{ user.email }}</div>
                                            </div>
                                        </div>
                                    </td>
                                    <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{{ user.role }}</td>
                                    <td class="px-6 py-4 whitespace-nowrap">
                                        <span class="px-2 inline-flex text-xs leading-5 font-semibold rounded-full"
                                              [ngClass]="user.status === 'Actif' ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'">
                                            {{ user.status }}
                                        </span>
                                    </td>
                                    <td class="px-6 py-4 whitespace-nowrap text-sm font-medium">
                                        <button (click)="viewUser(user)" class="text-gray-600 hover:text-gray-900 transition-colors" title="Voir l'utilisateur">
                                            <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                                            </svg>
                                        </button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div> -->
                </div>
            </div>
        </div>
    </div>

    <!-- Message si le plan n'est pas trouvé -->
    <div *ngIf="!isLoading && !plan" class="text-center py-20">
        <h2 class="text-xl font-semibold text-gray-700">Plan d'abonnement introuvable</h2>
        <p class="text-gray-500 mt-2">Veuillez vérifier l'identifiant du plan.</p>
        <button (click)="router.navigate(['/abonnements'])" class="mt-4 text-[#FF5C01] hover:text-[#E54F00] font-medium">
            Retourner à la liste des abonnements
        </button>
    </div>
</div>


<!-- 🆕 MODAL DE CONFIRMATION ACTIVATION/DÉSACTIVATION -->
<div *ngIf="showToggleModal" class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
    <div class="bg-white rounded-lg shadow-xl p-6 max-w-md w-full mx-4">
      <h3 class="text-lg font-semibold text-gray-900 mb-4">
        {{ plan?.active ? 'Désactiver' : 'Activer' }} le plan
      </h3>
      <p class="text-gray-600 mb-6">
        Êtes-vous sûr de vouloir {{ plan?.active ? 'désactiver' : 'activer' }} le plan
        <strong>"{{ plan?.label }}"</strong> ?
      </p>
      <div class="flex justify-end gap-3">
        <button
          (click)="cancelToggleAction()"
          class="px-4 py-2 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50 transition-colors">
          Annuler
        </button>
        <button
          (click)="confirmToggleAction()"
          [class]="plan?.active ? 'bg-red-600 hover:bg-red-700' : 'bg-green-600 hover:bg-green-700'"
          class="px-4 py-2 rounded-lg text-white transition-colors">
          {{ plan?.active ? 'Désactiver' : 'Activer' }}
        </button>
      </div>
    </div>
  </div>
  
  <!-- 🆕 MODAL DE CONFIRMATION SUPPRESSION -->
  <div *ngIf="showDeleteModal" class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
    <div class="bg-white rounded-lg shadow-xl p-6 max-w-md w-full mx-4">
      <div class="flex items-center gap-3 mb-4">
        <div class="w-12 h-12 rounded-full bg-red-100 flex items-center justify-center flex-shrink-0">
          <svg class="w-6 h-6 text-red-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
          </svg>
        </div>
        <div>
          <h3 class="text-lg font-semibold text-gray-900">Supprimer le plan</h3>
        </div>
      </div>
      <p class="text-gray-600 mb-6">
        Êtes-vous sûr de vouloir supprimer le plan <strong>"{{ plan?.label }}"</strong> ?
        <br><br>
        <span class="text-red-600 font-medium">Cette action est irréversible.</span>
      </p>
      <div class="flex justify-end gap-3">
        <button
          (click)="cancelDelete()"
          class="px-4 py-2 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50 transition-colors">
          Annuler
        </button>
        <button
          (click)="confirmDelete()"
          class="px-4 py-2 bg-red-600 hover:bg-red-700 text-white rounded-lg transition-colors">
          Supprimer
        </button>
      </div>
    </div>
  </div>
  
  <!-- 🆕 NOTIFICATION DE SUCCÈS -->
  <div *ngIf="showNotification" class="fixed top-4 right-4 bg-white rounded-lg shadow-xl p-4 w-80 z-[60] animate-slideIn">
    
    <!-- Notification Suppression -->
    <div *ngIf="notificationType === 'deleted'" class="flex items-start gap-3">
      <div class="w-10 h-10 rounded-full bg-red-100 flex items-center justify-center flex-shrink-0">
        <svg class="w-6 h-6 text-red-600" fill="currentColor" viewBox="0 0 20 20">
          <path fill-rule="evenodd"
            d="M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z"
            clip-rule="evenodd" />
        </svg>
      </div>
      <div class="flex-1">
        <p class="text-sm font-semibold text-gray-900 mb-1">Plan supprimé !</p>
        <p class="text-sm text-gray-600">
          Le plan <strong>"{{ planLabel }}"</strong> a été supprimé avec succès.
        </p>
      </div>
    </div>
  
    <!-- Notification Activation -->
    <div *ngIf="notificationType === 'activated'" class="flex items-start gap-3">
      <div class="w-10 h-10 rounded-full bg-green-100 flex items-center justify-center flex-shrink-0">
        <svg class="w-6 h-6 text-green-600" fill="currentColor" viewBox="0 0 20 20">
          <path fill-rule="evenodd"
            d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
            clip-rule="evenodd" />
        </svg>
      </div>
      <div class="flex-1">
        <p class="text-sm font-semibold text-gray-900 mb-1">Plan activé !</p>
        <p class="text-sm text-gray-600">
          Le plan <strong>"{{ planLabel }}"</strong> a été activé avec succès.
        </p>
      </div>
    </div>
  
    <!-- Notification Désactivation -->
    <div *ngIf="notificationType === 'deactivated'" class="flex items-start gap-3">
      <div class="w-10 h-10 rounded-full bg-orange-100 flex items-center justify-center flex-shrink-0">
        <svg class="w-6 h-6 text-orange-600" fill="currentColor" viewBox="0 0 20 20">
          <path fill-rule="evenodd"
            d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z"
            clip-rule="evenodd" />
        </svg>
      </div>
      <div class="flex-1">
        <p class="text-sm font-semibold text-gray-900 mb-1">Plan désactivé !</p>
        <p class="text-sm text-gray-600">
          Le plan <strong>"{{ planLabel }}"</strong> a été désactivé avec succès.
        </p>
      </div>
    </div>
  </div>
  
  <!-- Animation CSS -->
  <style>
  @keyframes slideIn {
    from {
      transform: translateX(100%);
      opacity: 0;
    }
    to {
      transform: translateX(0);
      opacity: 1;
    }
  }
  
  .animate-slideIn {
    animation: slideIn 0.3s ease-out;
  }
  </style>